import React from 'react';
import { KatSpinner } from '@amzn/katal-react';
import AppInitWrapper from 'src/components/AppInitWrapper';
import { ThemeProvider } from 'styled-components';
import { KatalTheme, GlobalStyle } from 'src/theme';
import AuthHydrater from 'src/state/providers/AuthHydrater';
import { Provider } from 'react-redux';
import { store } from 'src/state/store';
import ArbI18nextWrapper from 'src/i18n/ArbI18nextWrapper';
import { CprUrlFormattedRoute } from 'src/routes/helpers/CprUrlFormattedRoute';
import TranslationProvider from 'src/state/providers/TranslationProvider';

/**
 * This is a higher order component for wrapping the necessary context, wrappers, styles in CPR.
 */
const ApplicationShell = ({ children }) => {
  return (
    <React.StrictMode>
      <CprUrlFormattedRoute>
        <AppInitWrapper>
          <React.Suspense fallback={<KatSpinner size="large" />}>
            <ThemeProvider theme={KatalTheme}>
              <GlobalStyle />
              <Provider store={store}>
                <AuthHydrater>
                  <ArbI18nextWrapper>
                    <TranslationProvider>{children}</TranslationProvider>
                  </ArbI18nextWrapper>
                </AuthHydrater>
              </Provider>
            </ThemeProvider>
          </React.Suspense>
        </AppInitWrapper>
      </CprUrlFormattedRoute>
    </React.StrictMode>
  );
};

export { ApplicationShell };
